import { clone, map } from 'lodash';

export class Brand {
  id: string;
  description: string;
  name: string;
  phone_number: string;
  website: string;
  public_reference: string;
  logo: {};
  universes: any;
  legal_terms: string;
  stores = [];
  translation: any;
  primary_language: string;
  secondary_languages: string[];
  constructor(payload: Object = {}) {
    Object.assign(this, payload);
  }
}

export function fromApi(data) {
  data = clone(data);

  if (data.universes) {
    data.universes = map(data.universes, 'id');
  }

  return data;
}

export function toApi(data) {
  data = clone(data);

  if (data.logo && data.logo.id) {
    data.logo = data.logo.id;
  }
  delete data.description;

  return data;
}

